import moment from 'moment';

export const isIsoDateFormat = (dateString: string): boolean => {
  // ISO 8601 pattern: YYYY-MM-DDTHH:mm:ss[.ssssss][Z|±HH:MM]
  // Timezone piece is optional
  const iso8601Pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})?$/;

  return iso8601Pattern.test(dateString);
};

const parseDate = (dateString: string, localize: boolean): moment.Moment | null => {
  // attempt strict ISO parsing first to avoid moment warnings
  let parsed = localize ? moment(dateString, moment.ISO_8601, true) : moment.utc(dateString, moment.ISO_8601, true);

  if (!parsed.isValid()) {
    // fall back to JS Date parsing which handles a wider variety of strings
    const jsDate = new Date(dateString);
    if (Number.isNaN(jsDate.getTime())) {
      return null;
    }
    parsed = localize ? moment(jsDate) : moment.utc(jsDate);
  }

  return parsed.isValid() ? parsed : null;
};

const formatDate = (dateString: string, localize: boolean, dateFormat: string) => {
  const parsed = parseDate(dateString, localize);
  if (!parsed) {
    return isIsoDateFormat(dateString) ? dateString.split('T')[0] : dateString;
  }
  return localize ? parsed.local().format(dateFormat) : parsed.format(dateFormat);
};

/**
 * Formats a datestring but does not convert it to the user's timezone. Good for birth dates.
 */
export const formatStandardDate = (dateString: string) => formatDate(dateString, false, 'MM/DD/YYYY');

/**
 * Formats and localizes a datestring into a simple date format (M/D/YY).
 */
export const formatSimpleDate = (dateString: string) => formatDate(dateString, true, 'M/D/YY');

/**
 * Formats a datestring and also converts it to the user's timezone. Do not use for birth dates.
 */
export const formatStandardDateLocaleString = (dateString: string) => formatDate(dateString, true, 'MM/DD/YYYY');
